import addStartupScript from './principles/addStartupScript';
import * as eventTracking from './principles/event-tracking';
import * as formNavigation from './principles/leadform-navigation';
import * as formValidation from './principles/leadform-validation';
import * as formVariables from './principles/leadform-variables';
import './templates/account_creation';

addStartupScript(() => {
  formValidation.setUpFormValidation();
  formNavigation.setUpFormNavigation();
  formVariables.setUpFormVariables();
  eventTracking.trackEvents();
});
